import { ITrainingTemplateResource } from "../../training-templates";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITrainingSkillsTreeList } from "../types";

export interface ITrainingSkillsListQueryParameters {
    trainingTemplate: RelationalValue<ITrainingTemplateResource>;
}

export type ITrainingSkillsListQueryResult = ITrainingSkillsTreeList;

export const trainingSkillsListQuery: IApiQueryFunction<ITrainingSkillsListQueryParameters> = ({
    trainingTemplate,
}) => {
    if (!trainingTemplate) {
        return;
    }

    return {
        method: "GET",
        url: `/training_templates/${mapRelationalValue(trainingTemplate)}/skills-tree`,
    };
};

export const useTrainingSkillsListQuery = createApiQueryHook<
    ITrainingSkillsListQueryParameters,
    ITrainingSkillsListQueryResult
>(trainingSkillsListQuery);
